import React from "react";
import Lottie from "lottie-react";
import qrAnimation from "../../../assets/lottie/qr-success2.json";

export default function HeroSection({ t, onDownload }) {
  return (
    <section className="aq-hero">
      <div className="aq-container aq-hero-grid">
        <div className="aq-hero-text">
          <div className="aq-badge">{t("hero.badge")}</div>
          <h1>
            {t("hero.titleA")}{" "}
            <span className="aq-grad">{t("hero.titleB")}</span>{" "}
            {t("hero.titleC")}
          </h1>
          <p className="aq-muted">{t("hero.desc")}</p>
          <div className="aq-hero-actions">
            <button
              className="aq-btn aq-btn-solid aq-btn-download"
              onClick={onDownload}
            >
              {t("hero.cta1")}
            </button>
          </div>
        </div>

        <div className="aq-hero-media">
          <Lottie
            animationData={qrAnimation}
            loop
            autoplay
            className="aq-hero-lottie"
          />
        </div>
      </div>
    </section>
  );
}
